import type { TFunction } from 'i18next';
import type { OrderSupplierDraft } from './api/orderStockStatusApi';

export interface OrderSupplierDraftHistoryEntry {
  id: string;
  /** Set only for users who can open supplier orders (backend redaction). */
  supplierOrderId: string | null;
  at: string;
  title: string;
  author: string | null;
  notes: string | null;
}

/**
 * ZK card history entries of the confirmation draft ZD (decision 2026-10-04
 * pkt 4): "Szkic ZD utworzony" and, when Operations acted on it, "odrzucony"
 * (with the reason) or "przejrzany" (the ZD number). No prices — the
 * Handlowiec sees these too.
 */
export function buildSupplierDraftHistoryEntries(
  draft: OrderSupplierDraft | null | undefined,
  t: TFunction,
): OrderSupplierDraftHistoryEntry[] {
  if (!draft || draft.state === 'NONE') return [];
  const entries: OrderSupplierDraftHistoryEntry[] = [];
  if (draft.createdAt) {
    entries.push({
      id: 'supplier-draft-created',
      supplierOrderId: draft.supplierOrderId || null,
      at: draft.createdAt,
      title: t('orders:orderDetail.supplierDraftHistory.created', { number: draft.supplierOrderNumber || '' }),
      author: draft.createdByName || null,
      notes: null,
    });
  }
  if (draft.state === 'REJECTED' && draft.reviewedAt) {
    entries.push({
      id: 'supplier-draft-rejected',
      supplierOrderId: draft.supplierOrderId || null,
      at: draft.reviewedAt,
      title: t('orders:orderDetail.supplierDraftHistory.rejected'),
      author: draft.reviewedByName || null,
      notes: draft.rejectionReason
        ? t('orders:orderDetail.supplierDraftHistory.reason', { reason: draft.rejectionReason })
        : null,
    });
  }
  if (draft.state === 'REVIEWED' && draft.reviewedAt) {
    entries.push({
      id: 'supplier-draft-reviewed',
      supplierOrderId: draft.supplierOrderId || null,
      at: draft.reviewedAt,
      title: t('orders:orderDetail.supplierDraftHistory.reviewed', { number: draft.supplierOrderNumber || '' }),
      author: draft.reviewedByName || null,
      notes: null,
    });
  }
  return entries;
}
